import { JSX } from "react"

export const DataField = ({ paragraph, body }: { paragraph?: string, body?: string }): JSX.Element => {
    return <div className='data-field'>
        {paragraph ? <div className='strong'>&bull; {paragraph}</div> : undefined}
        {body}
    </div>
}